// extracted by mini-css-extract-plugin
export default {"shadowed":"ContactMe_shadowed__GQIu1","dark":"ContactMe_dark__2U5Jv","light":"ContactMe_light__ZDHOW","contactDark":"ContactMe_contactDark__uDgyy"};